import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/common.less'
import dataV from '@jiaminghi/data-view'
import axios from 'axios'
import * as echarts from 'echarts'
import VueCookies from "vue-cookies";

Vue.prototype.$echarts = echarts
Vue.prototype.$http= axios
Vue.config.productionTip = false

Vue.use(dataV)
Vue.use(VueCookies);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
